import { Alert } from '../Alert/Alert';
import styles from './StateMessage.module.css';

type StateType = 'loading' | 'error' | 'empty';

interface StateMessageProps {
  state: StateType;
  title?: string;
  message?: string;
}

const STATE_CONFIG = {
  loading: {
    variant: 'info',
    title: 'Loading',
    message: 'Please wait while we fetch data.',
  },
  error: {
    variant: 'error',
    title: 'Something went wrong',
    message: 'Please try again in a moment.',
  },
  empty: {
    variant: 'warning',
    title: 'No results yet',
    message: 'Run a search to view results.',
  },
} as const;

export function StateMessage({ state, title, message }: StateMessageProps) {
  const config = STATE_CONFIG[state];

  return (
    <Alert variant={config.variant}>
      <div className={styles.content}>
        <strong className={styles.title}>{title ?? config.title}</strong>
        <span className={styles.message}>{message ?? config.message}</span>
      </div>
    </Alert>
  );
}
